// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"311":"860e9f0b","429":"82e57603","681":"e391a0e4","842":"6170dda9","941":"2e7722c5"}[chunkId] + ".js";
};